import { useEffect, useState } from "react";
import GiftCardStatus from "./components/GiftCardStatus";
import CrossmintButton from "./components/CrossmintButton";
import { Box, Center, Heading, Spinner, Text, VStack } from "@chakra-ui/react";
import axios from "axios";
import { BACKEND_URL } from "./constants";
import MetaMaskButton from "./components/MetaMaskButton";

export default function Home() {
  const [profile, setProfile] = useState<any | undefined>({});
  const [address, setAddress] = useState<string | undefined>("");
  const [loading, setLoading] = useState(true);

  async function getMember() {
    try {
      setLoading(true);
      const { data } = await axios.post(`${BACKEND_URL}/owned`, {
        address,
      });

      setProfile({
        ...data,
        address,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (address) {
      getMember();
    } else {
      setLoading(false);
    }
  }, [address]);

  if (loading) {
    return (
      <Center>
        <Spinner />
      </Center>
    );
  }

  return (
    <Center>
      {profile.address ? (
        <VStack textAlign="center">
          <GiftCardStatus profile={profile} setProfile={setProfile} />
        </VStack>
      ) : (
        <Box textAlign="center">
          <Heading fontSize="lg" mb="20px">
            Gift Card Status
          </Heading>
          <CrossmintButton setAddress={setAddress} />
          <MetaMaskButton setAddress={setAddress} />
        </Box>
      )}
    </Center>
  );
}
